// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"e06edf6d","139":"c7cc883d","333":"eb6a684e","426":"e9d193c9","440":"e1c1aade","488":"d204888e","590":"52b51b5a","642":"6ade2463","726":"6b23049b","863":"d0e7eb96"}[chunkId] + ".chunk.js";
};